import PaymentData from 'components/PaymentData/styled';

export default PaymentData;
